module.exports = __webpack_public_path__ + "static/AHS.d9e0ce70.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/AHS.png
// module id = 112
// module chunks = 144251824217401 213534597649335